import {z} from 'zod';

// The plain photo (no watermark) that GET /dms/v2/sales/watermark/settings-preview draws on.
export const WatermarkSamplePhotoResponseBodySchema = z.object({
  // Base64 JPEG
  content: z.string(),
  width: z.number(),
  height: z.number(),
});
export type WatermarkSamplePhotoResponseBody = z.infer<
  typeof WatermarkSamplePhotoResponseBodySchema
>;
export type GetWatermarkSamplePhotoApiResponse = WatermarkSamplePhotoResponseBody & {
  base64Url: string;
};
